<template>
  <hm-content title="">
    <div class="flex mb10">
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        start-placeholder="请选择时间段"
        end-placeholder="请选择时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        class=" mr10 time"
      ></el-date-picker>
      <el-select
        clearable
        v-model="searchCondition.platformType"
        placeholder="请选择平台类型"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option label="拼多多" value="pdd"></el-option>
        <el-option label="京东" value="jd"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.orderHandleStatus"
        placeholder="请选择返佣状态"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option label="已返" value="yes"></el-option>
        <el-option label="未返" value="no"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.orderStatus"
        placeholder="请选择返佣状态"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option
          :label="v.text"
          :value="v.orderStatus"
          v-for="(v, i) in orderTypeList"
          :key="i"
        ></el-option>
      </el-select>
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.orderSn"
        placeholder="请输入订单号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="订单号"
          prop="orderSn"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="推荐人手机号"
          prop="mobile"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="下单时间"
          prop="orderTime"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsName"
          label="下单商品"
          width="200"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderAmount"
          label="付款金额"
        >
          <template slot-scope="scope">
            ￥ {{ ToFixed(scope.row.orderAmount / 100, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="platformPromotionRate"
          label="平台佣金比例"
        >
          <template slot-scope="scope">
            {{ ToFixed(scope.row.platformPromotionRate / 10, 2) }}%
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="platformPromotionAmount"
          label="平台预估佣金"
        >
          <template slot-scope="scope">
            ￥ {{ ToFixed(scope.row.platformPromotionAmount / 100, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="promotionRate"
          label="推广者佣金比例"
        >
          <template slot-scope="scope">
            {{ ToFixed(scope.row.promotionRate / 10, 2) }}%
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="promotionAmount"
          label="推广者佣金"
        >
          <template slot-scope="scope">
            ￥ {{ ToFixed(scope.row.promotionAmount / 100, 2) }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="enableState"
          label="平台利润"
        >
          <template slot-scope="scope">
            ￥
            {{
              ToFixed(
                (scope.row.platformPromotionAmount -
                  scope.row.promotionAmount) /
                  100,
                2
              )
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderStatusDesc"
          label="订单状态"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderHandleStatus"
          label="返佣状态"
        >
          <template slot-scope="scope">
            <div
              :class="
                scope.row.orderHandleStatus === 'no' ? 'danger' : 'success'
              "
            >
              {{ scope.row.orderHandleStatus === "no" ? "未返" : "已返" }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="enableState"
          label="下单人昵称"
        >
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="platformType"
          label="所属平台"
        >
          <template slot-scope="scope">
            {{ scope.row.platformType === "pdd" ? "拼多多" : "京东" }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button type="text" size="small" @click="details(scope.row)">
                查看详情
              </el-button>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { ToFixed } from "@/utils/utils";
export default {
  data() {
    return {
      ToFixed,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      orderTypeList: [
        {
          orderStatus: 0,
          text: "已支付"
        },
        {
          orderStatus: 1,
          text: "已成团"
        },
        {
          orderStatus: 2,
          text: "确认收货"
        },
        {
          orderStatus: 3,
          text: "审核成功"
        },
        {
          orderStatus: 4,
          text: "审核失败"
        },
        {
          orderStatus: 5,
          text: "已经结算"
        }
      ]
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    details(row) {
      console.log("row: ", row);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "taokeOrderInfoList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
